import { DateFormat } from '@blockworks/ui/legacy/datetime';
import { cn } from '@blockworks/ui/utils';

import WebinarCard, { WebinarCategory } from '@/components/display/cards/webinar-card';
import { WebinarStripped } from '@/types/article-type';

interface EventsSectionProps {
    webinars: WebinarStripped[];
    category: WebinarCategory;
    className?: string;
    lastElementRef?: (node: HTMLDivElement) => void;
}

const WebinarsSection = (props: EventsSectionProps) => {
    const { webinars, category, className, lastElementRef } = props;

    return (
        <div className="mb-10 flex flex-col justify-center items-center">
            <div className={cn('grid grid-cols-1 lg:grid-cols-2 w-full relative gap-10 py-4', className)}>
                {webinars.map((webinar, index) => (
                    <div
                        key={webinar.slug}
                        ref={index + 1 === webinars.length && category === 'ondemand' ? lastElementRef : null}
                    >
                        <WebinarCard
                            title={webinar.title}
                            category={category}
                            imageUrl={webinar.imageUrl}
                            date={
                                webinar.type === 'webinar' ? (
                                    <DateFormat dateStringOrTimestamp={webinar.date || 0} format="LLLL d, yyyy | p" />
                                ) : (
                                    webinar.textDate
                                )
                            }
                            description={webinar.content}
                            location={webinar.location}
                            sponsoredBy={webinar.sponsoredBy}
                            learnMoreLink={webinar.permalink}
                            registerLink={webinar.registrationButtonUrl || webinar.headerButtonUrl || null}
                            speakers={webinar.speakers}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default WebinarsSection;
